import {
  useQuery,
  type QueryKey,
  type UseQueryOptions,
} from '@tanstack/react-query'

import { useAuth } from '../useAuth'

export const useAuthenticatedQuery = <
  TQueryFnData = unknown,
  TError = unknown,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
>(
  options: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
) => {
  const { status } = useAuth()
  return useQuery<TQueryFnData, TError, TData, TQueryKey>({
    ...options,
    enabled: (options.enabled ?? true) && status === 'authenticated',
  })
}
